module.exports = __webpack_public_path__ + "img/table-icon-light.96e644ba.svg";